<template>
    <div>
        <v-row align="center">
            <v-col>
                <v-card>
                    <v-tabs grow v-model="$store.state.quality.departmentTab">
                        <v-tab>Tryg</v-tab>
                        <v-tab>Alka</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
            <v-col>
                <v-autocomplete
                    solo
                    hide-details
                    label="Team"
                    v-model="$store.state.quality.team"
                    :items="$store.getters['quality/teams']"
                />
            </v-col>
            <v-col>
                <v-switch
                    label="Inkl. inaktive"
                    v-model="$store.state.quality.inactive"
                />
            </v-col>
            <v-col>
                <v-text-field
                    hide-details
                    solo
                    v-model="$store.state.quality.searchString"
                    label="Søg"
                    prepend-inner-icon="fa-search"
                    clearable
                />
            </v-col>
            <v-col>
                <v-autocomplete
                    hide-details
                    solo
                    prefix="År"
                    v-model="$store.state.quality.year"
                    label="År"
                    :items="$store.state.quality.years"
                />        
            </v-col>
            <v-col>
                <v-autocomplete
                    hide-details
                    solo
                    prefix="Fra: Uge"
                    v-model="$store.state.quality.startWeek"
                    label="Uge"
                    :items="$store.getters['quality/weeks']"
                    :disabled="$store.state.quality.dateType === 'ytd'"
                />    
            </v-col>
            <v-col>
                <v-autocomplete
                    hide-details
                    solo
                    prefix="Til: Uge"
                    v-model="$store.state.quality.endWeek"
                    label="Uge"
                    :items="$store.getters['quality/weeks']"
                    :disabled="$store.state.quality.dateType !== 'range'"
                />
            </v-col>
            <v-col cols="2">
                <v-radio-group
                    row
                    :disabled="$route.name === 'QualityStatusRegistration'"
                    v-model="$store.state.quality.dateType"
                >
                    <v-radio value="single" label="Uge" />
                    <v-radio value="range" label="Periode" />
                    <v-radio value="ytd" label="ÅTD" />
                </v-radio-group>
            </v-col>
        </v-row>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        departmentTab () {
            return this.$store.state.quality.departmentTab
        },
        dateType () {
            return this.$store.state.quality.dateType
        },
        startWeek () {
            return this.$store.state.quality.startWeek
        },
        year () {
            return this.$store.state.quality.year
        }
    },
    watch: {
        departmentTab: function () {
            this.$store.state.quality.team = null
        },
        startWeek () {
            if (this.dateType === 'single') this.$store.state.quality.endWeek = this.$store.state.quality.startWeek
        },
        dateType: function () {
            if (this.dateType === 'single') this.$store.state.quality.endWeek = this.$store.state.quality.startWeek
            else if (this.dateType === 'ytd') {
                this.$store.state.quality.startWeek = 1
                this.$store.state.quality.endWeek = this.$store.getters['quality/weeks'][this.$store.getters['quality/weeks'].length - 1]
            }
        },
        year: function () {
            if (this.dateType === 'ytd') {
                this.$store.state.quality.startWeek = 1
                this.$store.state.quality.endWeek = this.$store.getters['quality/weeks'][this.$store.getters['quality/weeks'].length - 1]
            }
        }
    }
}
</script>